// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.line-widget {
  height: 98%;
  padding-top: 1rem;
  z-index: 1;
}

.flex-top-row {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  display: flex;
  flex-direction: row;
}
.flex-top-row .edit-icon {
  background-color: inherit;
  border: none;
}
.flex-top-row .view-title {
  flex-grow: 1;
  min-height: 1rem;
  max-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/widgets/line-widget/line-widget.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;EACA,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EACI,yBAAA;EACA,YAAA;AACR;AAEI;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;AAAR","sourcesContent":[".line-widget {\n    height: 98%;\n    padding-top: 1rem;\n    z-index: 1;\n}\n\n.flex-top-row {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 999;\n    display: flex;\n    flex-direction: row;\n\n    .edit-icon {\n        background-color: inherit;\n        border: none;\n    }\n\n    .view-title {\n        flex-grow: 1;\n        min-height: 1rem;\n        max-height: 1rem\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
